import classNames from "classnames";

// eslint-disable-next-line postcss-modules/no-unused-class
import style from "./Avatar.module.css";

interface AvatarProps {
  text?: string;
  children?: React.ReactNode;
  size?: "small" | "normal";
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ text, children, className, size = "normal" }) => {
  const initial = text && String.fromCodePoint(text.codePointAt(0) ?? 0).toUpperCase();

  return (
    <div className={classNames(style.avatar, style[size], className)}>
      {initial}
      {children}
    </div>
  );
};
